import * as React from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { ListWithHeader } from 'common/components/core/list/ListWithHeader';
import theme from './LearntAuditTaskList.scss';

class LearntAuditTaskList extends React.PureComponent {
    render() {
        const { theme, t, list, title } = this.props;
        return (
            <ListWithHeader
                className={theme.taskList}
                theme={theme}
                title={title}
            >
                {list.map((task, index) => {
                    const {
                        taskId,
                        completedLocation: { lat, lng }
                    } = task;
                    return (
                        <div key={index} className={theme.task}>
                            <span className={theme.title}>
                                {t('locationTable.taskId', { taskId })}
                            </span>
                            <span
                                className={theme.text}
                            >{`${lat}, ${lng}`}</span>
                        </div>
                    );
                })}
            </ListWithHeader>
        );
    }
}

export default compose(
    themr('LearntAuditTaskList', theme),
    translate('entityManagement')
)(LearntAuditTaskList);
